<template>
  <div>
    <div class="top-content">
      <ul
        v-if="categories.results"
        class="navbar for-sale-navbar"
      >
        <li v-if="userData">
          <router-link :to="{ name: 'user_listings' }">
            Your Listings
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'all_listings' }">
            All For Sale
          </router-link>
        </li>
        <li v-if="userData">
          <router-link :to="{ name: 'favorites', params: { id: userData.id } }">
            Your Favorites
          </router-link>
        </li>
        <li
          v-for="category of categories.results"
          :key="`sidebarCategory${category.id}`"
        >
          <router-link
            :to="{
              name: 'listing_category', params: { categorySlug: category.slug }
            }"
          >
            {{ category.name }}
          </router-link>
        </li>
      </ul>
      <spinner
        v-else-if="categories.loading"
        preset="large"
      />
      <template v-else-if="categories.error">
        <div
          class="alert alert-danger"
          role="alert"
        >
          Failed to load categories. Please check your connection and try again.
        </div>

        <button
          type="button"
          class="btn btn-outline-primary"
          @click="$store.dispatch('categories')"
        >
          Try Again
        </button>
      </template>
    </div>

    <div class="listings">
      <router-view />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState([
      'categories',
    ]),
  },
};
</script>

<style lang="scss" scoped>
  .for-sale-navbar {
    position: fixed;
    top: var(--header-height);
    margin: 0 -15px;
    width: 100%;
    z-index: 1;
  }

  .listings {
    margin-top: calc(22px + 1rem);
  }

  @media (min-width: 1024px) {
    .top-content {
      display: none;
    }

    .listings {
      margin-top: 0;
    }
  }
</style>
